export default "__VITE_ASSET__Cpg2LkhO__"